import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProviderRateReview } from "../slice/providerPanelRateReviewSlice";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar as fullStar,
  faStarHalfAlt as halfStar
} from '@fortawesome/free-solid-svg-icons';
import { faStar as emptyStar } from '@fortawesome/free-regular-svg-icons';

const ProviderRateReview = () => {

    const dispatch = useDispatch();
      const { providerRateReview } = useSelector((state) => state.providerRateReview);
      const providerToken = localStorage.getItem("provider_access_token");

      useEffect(() => {
          dispatch(getProviderRateReview(providerToken));
        }, [dispatch]);


        console.log("providerRateReview", providerRateReview);

    return (
      <>
      <style>
        {`
        .avatar-placeholder {
  width: 35px;
  height: 35px;
  background-color: #6c757d; /* dark grey */
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  margin-right: 14px;
}

.profile-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

         `}
      </style>
        
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                     <div className="ps-2 ps-lg-4">
                        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                           Rate & Review                    
                        </h4>



                        {Array.isArray(providerRateReview) && providerRateReview.length > 0 ? (
  providerRateReview.map((review, i) => {
    const fullStars = Math.floor(review.avg_rating);
    const hasHalfStar = review.avg_rating % 1 >= 0.25 && review.avg_rating % 1 < 0.75;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    const reviewerName = `${review.clients?.first_name ?? ''} ${review.clients?.last_name ?? ''}`.trim();
    const reviewDate = new Date(review.review_date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

    const profileImg = review.clients.profile_image;
    const clientName = review.clients.first_name;

    console.log("profileImg", profileImg);

    return (
      <div key={i} className="review-card">
        <div className="review-header mb-2">
          <div className="review-user">
           {profileImg ? (
  <img
    src={`${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${profileImg}`}
    alt="Profile"
    className="img-fluid"
  />
) : (
  <div className="avatar-placeholder">
    {clientName?.charAt(0).toUpperCase() || "U"}
  </div>
)}
            <h6 className="mb-0 montserrat font-weight-semibold">{reviewerName || 'Anonymous'}</h6>
          </div>
          <div className="review-meta">
          <div className="star-rating" style={{ color: "#f5c518" }}>
            {[...Array(fullStars)].map((_, i) => (
              <FontAwesomeIcon key={`avg-full-${i}`} icon={fullStar} />
            ))}
            {hasHalfStar && <FontAwesomeIcon icon={halfStar} />}
            {[...Array(emptyStars)].map((_, i) => (
              <FontAwesomeIcon key={`avg-empty-${i}`} icon={emptyStar} />
            ))}
          </div>
          <span className="review-date text-primary font-weight-medium">{reviewDate}</span>
        </div>
        </div>

        

        <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-muted">
          {review.review || "No review provided."}
        </p>

        {/* {review.clientRating?.length > 0 && (
          <ul className="ps-3 d-flex align-items-center gap-5 mt-3">
            {review.clientRating.map((rating, idx) => {
              const full = Math.floor(rating.rating);
              const half = rating.rating % 1 >= 0.25 && rating.rating % 1 < 0.75;
              const empty = 5 - full - (half ? 1 : 0);

              return (
                <li key={idx}>
                  <strong>{rating.rating_type}:</strong>
                  <span style={{ marginLeft: '8px', color: '#f5c518' }}>
                    {[...Array(full)].map((_, i) => (
                      <FontAwesomeIcon key={`full-${idx}-${i}`} icon={fullStar} />
                    ))}
                    {half && <FontAwesomeIcon icon={halfStar} />}
                    {[...Array(empty)].map((_, i) => (
                      <FontAwesomeIcon key={`empty-${idx}-${i}`} icon={emptyStar} />
                    ))}
                  </span>
                </li>
              );
            })}
          </ul>
        )} */}
      </div>
    );
  })
) : (
  <p>No reviews available.</p>
)}


                     </div>
                  </div>
        </>
        );
};

export default ProviderRateReview;
